import { useState } from "react";
import { useApiError } from "@infrastructure/api/hooks/useApiError";
import {
    createFinanceAllocationRuleAsync,
    updateFinanceAllocationRuleAsync,
    disableFinanceAllocationRuleAsync,
    enableFinanceAllocationRuleAsync,
} from "@features/admin/finance/allocation-rule/services/financeAllocationRuleSvc";
import {
    CreateFinanceAllocationRuleRequest,
    UpdateFinanceAllocationRuleRequest,
} from "@features/admin/finance/allocation-rule/types/financeAllocationRuleRequests";

export function useFinanceAllocationRuleAction() {
    const [busy, setBusy] = useState(false);
    const _showError = useApiError();

    const doCreate = async (nationId: number, data: CreateFinanceAllocationRuleRequest) => {
        setBusy(true);
        const response = await createFinanceAllocationRuleAsync(nationId, data);
        setBusy(false);
        return response;
    };

    const doUpdate = async (
        nationId: number,
        ruleGroupId: number,
        data: UpdateFinanceAllocationRuleRequest
    ) => {
        setBusy(true);
        const response = await updateFinanceAllocationRuleAsync(nationId, ruleGroupId, data);
        setBusy(false);
        return response;
    };

    const doDisable = async (nationId: number, ruleGroupId: number) => {
        setBusy(true);
        const response = await disableFinanceAllocationRuleAsync(nationId, ruleGroupId);
        setBusy(false);
        return response;
    };

    const doEnable = async (nationId: number, ruleGroupId: number) => {
        setBusy(true);
        const response = await enableFinanceAllocationRuleAsync(nationId, ruleGroupId);
        setBusy(false);
        return response;
    };

    return { busy, doCreate, doUpdate, doDisable, doEnable };
}
